<template>
  <div class="full">
    <div class="overlay" v-if="thinking">
      <div class="breeding-rhombus-spinner">
        <div class="rhombus child-1"></div>
        <div class="rhombus child-2"></div>
        <div class="rhombus child-3"></div>
        <div class="rhombus child-4"></div>
        <div class="rhombus child-5"></div>
        <div class="rhombus child-6"></div>
        <div class="rhombus child-7"></div>
        <div class="rhombus child-8"></div>
        <div class="rhombus big"></div>
      </div>
    </div>
    <div class="overlay" v-if="!registered">
      <div class="content">
        <h1>
          Tu dois entrer ton prénom et ton courriel pour discuter avec Tousky
        </h1>
        <form class="initial_info" @submit.prevent="register">
          <input
            for="prenom"
            name="prenom"
            v-model="firstName"
            type="text"
            placeholder="Quel est ton prénom?"
            required
          />
          <input
            for="email"
            name="email"
            type="email"
            v-model="email"
            placeholder="Quel est ton adresse courriel"
            required
          />
          <button class="myButton" type="submit">Accéder</button>
          <p>
            En entrant votre adresse e-mail et en cliquant sur le bouton
            'Accéder', vous acceptez de recevoir des e-mails promotionnels de
            notre part. Merci de votre confiance et de votre intérêt pour Tousky
            !"
          </p>
        </form>
      </div>
    </div>

    <div class="AI">
      <div class="chatbox">
        <div class="userQuestion" v-for="message in messages" :key="message.id">
          <div class="user_containerAI" v-if="message.from == 'Tousky'">
            <div class="textContainerAI">
              <div class="texteTousky" v-html="message.answer"></div>
            </div>
            <div class="avatarImageAI">
              <img src="../assets/img/Avatar.png" alt="OpenAI Avatar" />
            </div>
            <div class="avatarName">
              <p>{{ message.from }}</p>
            </div>
          </div>
          <div class="user_container" v-else>
            <div class="avatarImageAI">
              <img src="../assets/img/Avatar_humain.png" alt="Avatar" />
            </div>
            <div class="avatarName">
              <p>{{ message.from }}</p>
            </div>
            <div class="textContainerUser">
              <div class="texte" v-html="message.answer"></div>
            </div>
          </div>
          <!-- <div class="textContainerAI" v-if="message.from == 'Tousky'">
            <div class="texteTousky" v-html="message.answer"></div>
          </div>
          <div class="textContainerUser" v-else>
            <div class="texte" v-html="message.answer"></div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="AI">
      <div class="user_input">
        <form class="input-box" @submit.prevent="handleSubmit" ref="inputbox">
          <input
            type="text"
            v-model.lazy="inputText"
            placeholder="Quel est ta question?"
          />
          <button class="myButton" type="submit">Demander</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from "@/firebase";

export default {
  data() {
    return {
      messages: [
        {
          from: "Tousky",
          answer: "Bonjour, je m'appelle Tousky, comment puis-je t'aider?"
        }
      ],
      discussionDB: [
        {
          from: "Tousky",
          answer: "Bonjour, je m'appelle Tousky, comment puis-je t'aider?"
        }
      ],
      firstName: "",
      email: "",
      inputText: "",
      question: "",
      date: "",
      registered: false,
      docRef: "",
      timestamp: "",
      thinking: false,
      answer: ""
    };
  },

  async mounted() {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, "0");
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    this.date = day + "." + month;
    this.timestamp = serverTimestamp();
  },

  computed: {
    formIsValid() {
      return this.$refs.form.checkValidity() && this.validateEmail();
    }
  },

  methods: {
    checkIfIngredients() {
      const ingredientsPattern = /\b(ingredient|ingrédient)s?\b/i;
      return this.answer.match(ingredientsPattern) !== null;
    },

    async register() {
      const validation = this.validateEmail();
      if (validation == true) {
        this.registered = true;
      }

      this.docRef = this.date + " " + this.email;

      const querySnapshot = await getDocs(collection(db, "Conversation-AI"));
      querySnapshot.forEach((doc) => {
        if (doc.id == this.docRef) {
          this.discussionDB = doc.data().message;
        }
      });
    },

    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.email);
    },

    async handleSubmit() {
      this.question = this.inputText;
      this.messages.push({
        from: this.firstName,
        answer: this.question
      });
      this.discussionDB.push({
        from: this.firstName,
        answer: this.question
      });
      this.$refs.inputbox.reset();
      this.inputText = "";
      this.callOpenAPI().then(() => {
        this.scrollToBottom();
      });
    },

    async callOpenAPI() {
      const apiKey = process.env.VUE_APP_OPENAI_API_KEY;
      const url = "https://api.openai.com/v1/chat/completions";
      this.thinking = true;
      const params = {
        messages: [
          {
            role: "system",
            // content:
            //   "Tu t'appelles Tousky. Tu es le petit robot de la compagnie Human Way qui vends de la viande éthique et responsable (nourri à l'herbe, en pâturage et en liberté). Chaque fois que tu mentionnes de la viande, assure toi de mettre la viande Human Way. Tu es toujours amical. Nous n'avons aucun magasin physique"
            content:
              "Bonjour! Je suis Tousky, le petit robot de la compagnie Human Way qui vends de la viande éthique et responsable. Nous avons du boeuf nourri à l'herbe, du poulet élevé en liberté et du porc de pâturage. Je suis programmé pour répondre à vos questions en utilisant mes connaissances sur la nutrition et la santé. Mes réponses seront basées sur les informations que j'ai apprises à partir de deux livres récents: 'Pegan Diet' et 'The Wahls Protocol'. Posez-moi votre question et je ferai de mon mieux pour vous aider! Je proposerai, lorsque possible, la viande Human Way."
          },
          {
            role: "user",
            content: this.question
          }
        ],
        model: "gpt-3.5-turbo",
        max_tokens: 500,
        temperature: 0.7
      };

      try {
        const response = await axios.post(url, params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`
          }
        });
        this.messages.push({
          from: "Tousky",
          answer:
            "<div style='font-family: Raleway, sans-serif; font-size: 14px; white-space: pre-wrap;'>" +
            response.data.choices[0].message.content +
            "</div>"
        });
        this.discussionDB.push({
          from: "Tousky",
          answer: response.data.choices[0].message.content
        });

        this.answer = response.data.choices[0].message.content;

        console.log(this.checkIfIngredients());

        setDoc(
          doc(db, "Conversation-AI", this.date + " " + this.email),
          { timestamp: this.timestamp, message: this.discussionDB },
          { merge: true }
        );
        this.thinking = false;
        this.scrollToBottom();
      } catch (error) {
        console.error(error);
      }
    },

    scrollToBottom() {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }
};
</script>

<style scoped>
h1 {
  color: #fff;
  text-align: center;
}

p {
  color: #fff;
}

.AI {
  display: flex;
  justify-content: center;
  position: relative;
}

.full {
  position: relative;
}

.myButton {
  box-shadow: 0px 10px 14px -7px #3e7327;
  background: #177300;
  background-color: #177300;
  border-radius: 4px;
  border: 1px solid #177300;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
  padding: 6px 12px;
  text-decoration: none;
  text-shadow: 0px 1px 0px #5b8a3c;
}
.myButton:hover {
  background: linear-gradient(to bottom, #72b352 5%, #77b55a 100%);
  background-color: #72b352;
}
.myButton:active {
  position: relative;
  top: 1px;
}

.chatbox {
  overflow-y: auto;
  width: 90%;
  height: 500px;
  background-color: #000;
  color: #fff;
  border: 5px solid #fff;
}

.chatbox p {
  color: white;
}

.texte {
  color: #ffffff;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  line-height: 150%;
  margin: 1rem 2rem;
}

.texteTousky {
  color: #ffffff;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  line-height: 150%;
  margin: 1rem 2rem;
}

.textContainerAI {
  display: flex;
  align-items: center;
  background-color: #134060;
  border-radius: 25px;
  width: 80%;
  min-height: 50px;
}

.textContainerUser {
  display: flex;
  align-items: center;
  background-color: #177300;
  border-radius: 25px;
  width: 80%;
  min-height: 50px;
}

.userQuestion {
  margin: 1rem 5rem 0 1rem;
  /* margin-left: 5rem; */
  word-wrap: break-word;
  display: flex;
  align-items: center;
  /* margin-right: 1rem; */
}

.user_containerAI {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.user_container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.avatarImageAI img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  margin: 5px;
}

.avatarName {
  display: flex;
  margin-right: 2rem;
}

.avatarName p {
  font-weight: bold;
}

.user_input {
  margin-top: 1rem;
  overflow-y: auto;
  background-color: #fff;
  color: #fff;
  width: 90%;
}

.input-box {
  display: flex;
  margin: 10px;
  /* max-width: 85%; */
}

.input-box input {
  flex-grow: 1;
  padding: 5px;
  border: 1px solid black;
  border-radius: 5px;
  margin-right: 5px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  width: 50%;
  background-color: #fff;
  padding: 2rem;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
}

.content h1 {
  color: black;
  margin-bottom: 1rem;
}

.content input[type="email"] {
  padding: 0.5rem;
  border: none;
  border-bottom: 1px solid #ccc;
  margin-right: 0.5rem;
  width: 50%;
  display: block;
}

.content input[type="text"] {
  padding: 0.5rem;
  border: none;
  border-bottom: 1px solid #ccc;
  margin-right: 0.5rem;
  width: 50%;
  display: block;
}

.content button {
  width: 100px;
  margin-top: 1rem;
}

.initial_info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.initial_info p {
  color: #000;
  font-size: small;
}

.breeding-rhombus-spinner {
  display: flex;
  height: 65px;
  width: 65px;
  position: absolute;
  top: 40%;
  left: 50%;
  z-index: 4;
  transform: rotate(45deg);
}

.breeding-rhombus-spinner,
.breeding-rhombus-spinner * {
  box-sizing: border-box;
}

.breeding-rhombus-spinner .rhombus {
  height: calc(65px / 7.5);
  width: calc(65px / 7.5);
  animation-duration: 2000ms;
  top: calc(65px / 2.3077);
  left: calc(65px / 2.3077);
  background-color: #177300;
  position: absolute;
  animation-iteration-count: infinite;
}

.breeding-rhombus-spinner .rhombus:nth-child(2n + 0) {
  margin-right: 0;
}

.breeding-rhombus-spinner .rhombus.child-1 {
  animation-name: breeding-rhombus-spinner-animation-child-1;
  animation-delay: calc(100ms * 1);
}

.breeding-rhombus-spinner .rhombus.child-2 {
  animation-name: breeding-rhombus-spinner-animation-child-2;
  animation-delay: calc(100ms * 2);
}

.breeding-rhombus-spinner .rhombus.child-3 {
  animation-name: breeding-rhombus-spinner-animation-child-3;
  animation-delay: calc(100ms * 3);
}

.breeding-rhombus-spinner .rhombus.child-4 {
  animation-name: breeding-rhombus-spinner-animation-child-4;
  animation-delay: calc(100ms * 4);
}

.breeding-rhombus-spinner .rhombus.child-5 {
  animation-name: breeding-rhombus-spinner-animation-child-5;
  animation-delay: calc(100ms * 5);
}

.breeding-rhombus-spinner .rhombus.child-6 {
  animation-name: breeding-rhombus-spinner-animation-child-6;
  animation-delay: calc(100ms * 6);
}

.breeding-rhombus-spinner .rhombus.child-7 {
  animation-name: breeding-rhombus-spinner-animation-child-7;
  animation-delay: calc(100ms * 7);
}

.breeding-rhombus-spinner .rhombus.child-8 {
  animation-name: breeding-rhombus-spinner-animation-child-8;
  animation-delay: calc(100ms * 8);
}

.breeding-rhombus-spinner .rhombus.big {
  height: calc(65px / 3);
  width: calc(65px / 3);
  animation-duration: 2000ms;
  top: calc(65px / 3);
  left: calc(65px / 3);
  background-color: #177300;
  animation: breeding-rhombus-spinner-animation-child-big 2s infinite;
  animation-delay: 0.5s;
}

@keyframes breeding-rhombus-spinner-animation-child-1 {
  50% {
    transform: translate(-325%, -325%);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-2 {
  50% {
    transform: translate(0, -325%);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-3 {
  50% {
    transform: translate(325%, -325%);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-4 {
  50% {
    transform: translate(325%, 0);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-5 {
  50% {
    transform: translate(325%, 325%);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-6 {
  50% {
    transform: translate(0, 325%);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-7 {
  50% {
    transform: translate(-325%, 325%);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-8 {
  50% {
    transform: translate(-325%, 0);
  }
}

@keyframes breeding-rhombus-spinner-animation-child-big {
  50% {
    transform: scale(0.5);
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 80%;
  }

  .content input[type="email"] {
    width: 100%;
  }

  .content input[type="text"] {
    width: 100%;
  }

  .userQuestion {
    margin: 1rem 0 0 1em;
  }

  .textContainerUser {
    margin-right: 1rem;
  }
}
</style>
